import React from 'react';
import Navbar from '../../Shared/Navbar/Navbar';

const DashboardPage = () => {
    return (
        <div>
            <Navbar></Navbar>
            <h1>I am from DashboardPage</h1>
        </div>
    );
};

export default DashboardPage;